import React from "react";
import blurBg from "../../svgs/home/bg-blur.svg";
import Button from "../UI/Button";
import Range from "./Range";

export default function MainDiv() {
  return (
    <>
      <div className="h-[924px] relative z-30 w-full ">
        <div className="w-full h-full absolute">
          <img
            src="/backgrounds/home_1.jpeg"
            alt="background"
            className="h-[924px] object-cover "
          />
        </div>
        <div className="z-10 w-full lg:w-[400px] absolute mx-auto left-0 right-0 top-24 items-center flex flex-col">
          <div className="mt-24 mb-10 w-3/4 lg:w-full flex justify-center">
            <img src="/images/home/main-logo.png" alt="background" />
          </div>
          <div>
            <Button
              width="130px"
              height="40px"
              text="Play"
              isGreen={true}
              textColor="#256200"
              largeMobileText={true}
            />
          </div>
          <div className="mt-8 z-50 relative lg:w-[750px] lg:h-[132px]">
            <div className="absolute -z-10">
              <img src={blurBg} alt="background" className="lg:block hidden" />
            </div>
            <Range />
          </div>
        </div>
      </div>
    </>
  );
}
